import EmojiTextInput from './EmojiTextInput'

import EmojiInput from './EmojiInput'

export { EmojiTextInput, EmojiInput }

export default EmojiTextInput
